// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","main":"Logo_main__kCFcl","detail":"Logo_detail__tEPOk","shadow":"Logo_shadow__JdbQl"};